import { useCallback } from 'react';
import { KeycloakLogin } from '@studio-toolkit/keycloak';
import useQuantum from './useQuantum';
import { primaryRequestInstance } from 'utils';

type TLoginStop = Required<
  React.ComponentProps<typeof KeycloakLogin>
>['onLoginStop'];

const useLogin = () => {
  const { trackLoginStart, trackLoginStop } = useQuantum();
  const handleLoginStart = useCallback(() => {
    trackLoginStart('ssoAuth');
  }, [trackLoginStart]);

  const handleLoginStop: TLoginStop = useCallback(
    ({ authenticated, keycloakUser, token }) => {
      trackLoginStop(authenticated, { accountGUID: keycloakUser?.email });
      if (token) {
        primaryRequestInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
      } else {
        delete primaryRequestInstance.defaults.headers.common.Authorization;
      }
    },
    [trackLoginStop]
  );
  return { handleLoginStart, handleLoginStop };
};

export default useLogin;
